@if((label$ | async) !== null){
  @switch (bannerStyle) {
    @case ('Full') {
      <div class="flex bg-purple-50 rounded-[3px] p-5">        
            <p class="mx-auto text-white" [innerHtml]="label$ | async"></p>
      </div>        
    }
  }
}
